import ClientHelper from "core/ClientHelper";
import StringHelper from "core/StringHelper";
import React from "react";
import { Column } from "react-virtualized";
import { GridColumnType } from "views/Constants/Constant";

export function GetIncomingWireColumns() {
   return [
      {
         Header: "Id",
         accessor: "Id",
         show: false,
      },
      {
         Header: "Organization",
         accessor: "Organization",
      },
      {
         Header: "Request Date",
         accessor: "WireRequestDate",
         type: GridColumnType.DateUtc,
      },
      {
         Header: "Wire Transaction Date",
         accessor: "WireTransactionDate",
         type: GridColumnType.DateUtc,
      },
      {
         Header: "Status",
         accessor: "Status",
         show: ClientHelper.IsBackOffice(),
      },
      {
         Header: "SubStatus",
         accessor: "SubStatus",
         show: ClientHelper.IsBackOffice(),
      },
      {
         Header: "Beneficiary Client",
         accessor: "Name",
      },
      {
         Header: "Beneficiary Account Number",
         accessor: "AccountNumber",
      },
      {
         Header: "Amount",
         accessor: "Amount",
         type: GridColumnType.Money,
         ColumnType: GridColumnType.Money,
      },
      {
         Header: "Receiver",
         accessor: "AliasReceiver",
         highlightIfValue: { noValueStyle: { backgroundColor: "#f44336" } },
      },
      {
         Header: "Ordering Client Name",
         accessor: "OrderingClientName",
      },
      {
         Header: "Ordering Source Account",
         accessor: "OrderingSourceAccountNumber",
      },
      {
         Header: "Sending FI",
         accessor: "SendingFI",
      },
      {
         Header: "Sending FI Country",
         accessor: "SendingFICountry",
      },
      {
         Header: "International Bank Country",
         accessor: "InternationalBankCountry",
      },
   ];
}

export function GetGeneralWireColumns() {
   return [
      {
         Header: "Client Name",
         accessor: "ClientName",
      },
      {
         Header: "Swift Reference Number",
         accessor: "SwiftReferenceNumber",
      },
      {
         Header: "Transaction Reference Number",
         accessor: "TransactionReferenceNumber",
      },
      {
         Header: "Source Wallet Number",
         accessor: "FromAccAccountNumber",
      },
      {
         Header: "To Wallet Number",
         accessor: "ToAccountNumber",
      },

      {
         Header: "Direction",
         accessor: "Direction",
      },
      {
         Header: "Status",
         accessor: "Status",
      },
      {
         Header: "SubStatus",
         accessor: "SubStatus",
         show: ClientHelper.IsBackOffice(),
      },

      {
         Header: "Date of Request",
         accessor: "DateRequest",
         type: GridColumnType.DateUtc,
      },
      {
         Header: "Value Effective",
         accessor: "ValueEffective",
         type: GridColumnType.DateUtc,
      },
      {
         Header: "Amount",
         accessor: "Amount",
         type: GridColumnType.Money,
         ColumnType: GridColumnType.Money,
      },
      {
         Header: "Fee Amount",
         accessor: "FeeAmount",
         type: GridColumnType.Money,
         ColumnType: GridColumnType.Money,
      },
      {
         Header: "Currency",
         accessor: "CurrencyName",
      },
      {
         Header: "Remittance",
         accessor: "Remittance",
      },
      {
         Header: "Beneficiary Identifier",
         accessor: "BeneficiaryIdentifier",
      },

      {
         Header: "Swift Benefiary Wallet Number",
         accessor: "BeneficiaryAccountNumber",
      },
      {
         Header: "Swift Beneficiary Name",
         accessor: "BeneficiaryName",
      },
      {
         Header: "Bank Opearation Code",
         accessor: "BankOperationCode",
      },
      {
         Header: "Sender Wallet Number",
         accessor: "SenderAccountNumber",
      },
      {
         Header: "Sender Swift Code",
         accessor: "SenderSwiftCode",
      },
      {
         Header: "Sender Name",
         accessor: "SenderName",
      },
      {
         Header: "Sender Address",
         accessor: "SenderAddress",
      },
      {
         Header: "Sender Additional Information",
         accessor: "SenderAdditionalInformation",
      },
      {
         Header: "Ordering Institution Swift Code",
         accessor: "OrderingInstitutionSwiftCode",
      },
      {
         Header: "Ordering Institution Party Identifier",
         accessor: "OrderingInstitutionPartyIdentifier",
      },
      {
         Header: "Ordering Institution Party Address",
         accessor: "OrderingInstitutionAddress",
      },
      {
         Header: "Intermediary Name",
         accessor: "IntermediaryName",
      },
      {
         Header: "Beneficiary Bank Party Identifier",
         accessor: "BeneficiaryBankPartyIdentifier",
      },
      {
         Header: "Details Of Charges",
         accessor: "DetailsOfCharges",
      },
      {
         Header: "Sender Party Identifier Wallet",
         accessor: "WireTransferMessageSenderParty.Account",
      },
      {
         Header: "Sender Party Identifier Code",
         accessor: "WireTransferMessageSenderParty.Code",
      },
      {
         Header: "Sender Party Identifier CountryCode",
         accessor: "WireTransferMessageSenderParty.CountryCode",
      },
      {
         Header: "Sender Party Identifier Identifier",
         accessor: "WireTransferMessageSenderParty.Identifier",
      },
      {
         Header: "Beneficiary Company Name",
         accessor: "CompanyName",
      },
      {
         Header: "Country",
         accessor: "CountryFormat",
      },
   ];
}
